import React, { useState } from 'react';
import {
    Paper,
    Table,
    TableBody,
    TableRow,
    TableCell,
    TextField,
    Checkbox,
    DialogTitle,
    DialogContent,
    TableContainer,
    Button,
    Grid,
    DialogActions,
    Typography,
    Box
} from '@material-ui/core';
import { CheckCircleOutline, Close } from '@material-ui/icons';
import { moneyFormat } from 'src/utils/Common';

export function AddLabour({ labours = [], initialSelectedLabourIds = [], currency, tanentCode, onDone, onAbort }) {
    const [filter, setFilter] = useState('');
    const [selectedLabourIds, setSelectedLabourIds] = useState([...initialSelectedLabourIds]);

    const filteredLabours = labours.filter(
        l => l.LabourDesc?.toLowerCase?.()?.includes?.(filter) || l.LabourCode?.toLowerCase?.().includes?.(filter)
    );

    const handleAddLabour = labourId => {
        setSelectedLabourIds(state => {
            state.push(labourId);
            return [...state];
        });
    };

    const handleDeleteLabour = labourId => {
        setSelectedLabourIds(state => {
            const index = state.indexOf(labourId);
            if (index !== -1) {
                state.splice(index, 1);
            }
            return [...state];
        });
    };

    const handleDone = () => {
        onDone(selectedLabourIds);
    };

    return (
        <>
            <Grid container justifyContent="space-between">
                <Grid item>
                    <DialogTitle>Add Labours</DialogTitle>
                </Grid>
            </Grid>
            <DialogContent>
                <TextField
                    value={filter}
                    onChange={e => setFilter(e.target.value.toLowerCase())}
                    fullWidth
                    type="search"
                    placeholder="Enter the labour code or name"
                    style={{ marginBottom: 8 }}
                ></TextField>

                <TableContainer
                    component={Paper}
                    style={{ height: 400, width: 440, overflowY: 'auto', userSelect: 'none' }}
                >
                    {!filteredLabours.length ? (
                        <Box mt={10}>
                            <Typography align="center" variant="h5">
                                No result
                            </Typography>
                        </Box>
                    ) : (
                        <Table size="small">
                            <TableBody>
                                {filteredLabours.map(labour => (
                                    <TableRow
                                        key={labour.LabourId}
                                        hover
                                        onClick={() => {
                                            selectedLabourIds.includes(labour.LabourId)
                                                ? handleDeleteLabour(labour.LabourId)
                                                : handleAddLabour(labour.LabourId);
                                        }}
                                    >
                                        <TableCell>{labour.LabourDesc}</TableCell>
                                        <TableCell align="right" style={{ padding: 0 }}>
                                            {moneyFormat(labour.Price, tanentCode, currency)}
                                        </TableCell>
                                        <TableCell>{currency}</TableCell>
                                        <TableCell padding="checkbox">
                                            <Checkbox
                                                color="primary"
                                                checked={selectedLabourIds.includes(labour.LabourId)}
                                            />
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    )}
                </TableContainer>
            </DialogContent>
            <DialogActions>
                <Button
                    size="small"
                    color="primary"
                    variant="contained"
                    onClick={handleDone}
                    endIcon={<CheckCircleOutline />}
                >
                    Done
                </Button>
                <Button size="small" color="secondary" variant="outlined" onClick={onAbort} endIcon={<Close />}>
                    Abort
                </Button>
            </DialogActions>
        </>
    );
}
